import { render, staticRenderFns } from "./NotifBreakdownWidget.vue?vue&type=template&id=39911b24&"
import script from "./NotifBreakdownWidget.vue?vue&type=script&lang=js&"
export * from "./NotifBreakdownWidget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports